<template src="./u-button.html" />
<script src="./u-button.ts" lang="ts"></script>
<style src="node-waves/src/scss/waves.scss" lang="scss"></style>
<style src="./u-button.scss" scoped lang="scss"></style>
